import { TextWithIcon } from '@/components/atomic/nuclei';
import { CART_STATUS, DEVICE_SURFACE, ORDER_STATUS } from '@/config/common';
import { GetUiDeviceSurface } from '@/helpers/screenResolutionHelper';
import { convertToShortMonthDateFormat } from '@/lib/time';
import { parseNumberedLabel } from '@/lib/utils';

const CartInnerBody = ({
  cartCreatedBy,
  createdAt,
  isMobile = false,
  isOrdered,
  orderNumber = '',
  orderStatusClass
}) => {
  const cartKeyValuePairs = [
    {
      alt: 'event planner icon',
      className: '',
      icon: 'event-planner-brand-icon.svg',
      iconHeight: 20,
      iconWidth: 20,
      id: 'event-planner-name',
      label: cartCreatedBy,
      labelStyle: `text-nero text-sm font-light ${orderStatusClass}`
    },
    {
      alt: 'calender icon',
      className: '',
      icon: 'calendar-brand-icon.svg',
      iconHeight: 20,
      iconWidth: 20,
      id: 'cart-creation-date',
      label: convertToShortMonthDateFormat(createdAt),
      labelStyle: `text-nero text-sm font-light ${orderStatusClass}`
    },
    {
      alt: 'order icon',
      className: '',
      icon: 'order-brand-icon.svg',
      iconHeight: 20,
      iconWidth: 20,
      id: 'order-number',
      label: parseNumberedLabel(orderNumber),
      labelStyle: `text-nero text-sm font-light cursor-pointer ${
        isMobile ? '' : 'hover:text-brand'
      } ${orderStatusClass}`,
      visible: isOrdered
    }
  ];
  return (
    <div
      className={`flex flex-wrap gap-4 flex-row gap-y-4 text-sm mt-3 ${
        isMobile ? 'justify-between' : ''
      } ${orderStatusClass}`}
    >
      {cartKeyValuePairs.map(
        (
          {
            alt,
            className,
            icon,
            iconHeight,
            iconWidth,
            id,
            label,
            labelStyle,
            onClick = () => {},
            tooltipText,
            visible = true
          },
          index
        ) => (
          <TextWithIcon
            key={index}
            {...{
              alt,
              className,
              icon,
              iconHeight,
              iconWidth,
              id,
              label,
              labelStyle,
              onClick,
              onHoverCopy: true,
              show: visible,
              tooltipText
            }}
          />
        )
      )}
    </div>
  );
};

const CartCardBodyWeb = ({
  cartCreatedBy,
  cartOrder,
  createdAt,
  isOrdered,
  orderStatusClass
}) => (
  <div className='flex flex-col md:flex-row items-center justify-between'>
    <CartInnerBody
      {...{
        cartCreatedBy,
        createdAt,
        isOrdered,
        orderId: cartOrder?.order.id,
        orderNumber: cartOrder?.order.orderNumber,
        orderStatusClass
      }}
    />
  </div>
);

const CartCardBodyMobile = ({
  cartCreatedBy,
  cartOrder,
  createdAt,
  isOrdered,
  orderStatusClass
}) => (
  <div className='flex flex-col md:flex-row gap-2 text-sm'>
    <CartInnerBody
      {...{
        cartCreatedBy,
        createdAt,
        isMobile: true,
        isOrdered,
        orderId: cartOrder?.order.id,
        orderNumber: cartOrder?.order.orderNumber,
        orderStatusClass
      }}
    />
  </div>
);

const CartCardBody = ({ cartCreatedBy, cartOrder, createdAt, status }) => {
  const surface = GetUiDeviceSurface();
  const CartCardBodyMap = {
    [DEVICE_SURFACE.MOBILE]: CartCardBodyMobile,
    [DEVICE_SURFACE.WEB]: CartCardBodyWeb
  };

  const CartBody = CartCardBodyMap[surface];

  const isOrdered = status === CART_STATUS.ORDER.value;
  const isOrderInCancelledState =
    isOrdered && cartOrder.order.status === ORDER_STATUS.CANCELLED.value;
  const orderStatusClass = isOrderInCancelledState ? 'cancelled' : '';

  return (
    <CartBody
      {...{
        cartCreatedBy,
        cartOrder,
        createdAt,
        isOrdered,
        orderStatusClass
      }}
    />
  );
};

export default CartCardBody;
